<template>
  <router-view></router-view>
  <notifications position="bottom right" />
</template>

<script>
export default {
  name: "app",
  async beforeCreate() {
    const token = await window.localStorage.getItem("token");
    this.$store.dispatch("setToken", token);
  },
};
</script>

<style lang="scss">
@use "@monolith/styles";

body {
  margin: 0;
  padding: 0;
  font-family: "Lato";
  color: var(--text-colour);
  background-color: var(--tertiary-colour);

  .vue-notification-group {
    z-index: 111111 !important;

    .vue-notification {
      font-size: 24px;
    }
  }

  #app {
    overflow: hidden;
  }

  form {
    font-size: 1em;
    label {
      display: block;
      font-size: 0.8em;
      font-weight: bold;
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
    }
    input[type="file"],
    input[type="number"],
    input[type="tel"],
    input[type="email"],
    input[type="password"],
    textarea {
      padding: 0.7rem;
      border-radius: 0.3rem;
      border: 1px solid #ccc;
      margin-bottom: 0.5rem;
      width: calc(100% - 2rem);
    }
  }

  button {
    padding: 1rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    background-color: var(--action-colour);
    font-size: 1rem;
    color: var(--secondary-text-colour);
    font-family: "Lato";
    margin: 0 1rem;
    display: inline-block !important;
    cursor: pointer;
    &:focus-visible {
      outline: 2px solid var(--action-colour);
      outline-offset: 2px;
    }
  }

  button.primary {
    background-color: var(--action-colour) !important;
  }

  button.persist {
    background-color: #65da3b !important;
  }

  button.warning {
    background-color: #ff9700 !important;
  }

  button.danger {
    background-color: #ff003b !important;
  }

  button.action {
    padding: 0.7rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    background-color: #ddd;
    margin: 0.5rem;
    width: 200px;
    display: inline-block !important;
  }

  .ql-container {
    background-color: var(--primary-colour);
  }
  .ql-toolbar {
    background-color: var(--secondary-text-colour);
  }
}
</style>
